/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import PropTypes from 'prop-types';

export const Summary = {
  aggregationInfoList: PropTypes.arrayOf(PropTypes.object),
  ready: PropTypes.bool,
  dimensionNames: PropTypes.arrayOf(PropTypes.string),
  granularityName: PropTypes.string,
  granularityTimeFrequency: PropTypes.string,
  hasDashboardMeta: PropTypes.bool,
};

export const SummaryPropTypes = PropTypes.shape(Summary);

export const SummariesPropTypes = PropTypes.arrayOf(SummaryPropTypes);

export const DashboardPropTypes = PropTypes.shape({
  // eslint-disable-next-line react/forbid-prop-types
  dashboardMetadataJson: PropTypes.object,
  description: PropTypes.string,
  summaryDto: SummaryPropTypes,
});

export const DashboardsPropTypes = PropTypes.arrayOf(DashboardPropTypes);

export const DashboardPinPropTypes = PropTypes.shape({
  category: PropTypes.string,
  createTimestamp: PropTypes.string,
  dashboardPinId: PropTypes.number,
  description: PropTypes.string,
  // can be string, array, or object depending on use
  // eslint-disable-next-line react/forbid-prop-types
  filterJson: PropTypes.any,
  favorite: PropTypes.bool,
  homePage: PropTypes.bool,
  summary: PropTypes.bool,
  name: PropTypes.string,
  thumbnail: PropTypes.string,
  updateTimestamp: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  resourceDto: PropTypes.object,
  deviceId: PropTypes.string,
  dashboardMetaId: PropTypes.number,
});

export const DashboardPinsPropTypes = PropTypes.arrayOf(DashboardPinPropTypes);
